import React from 'react';
import './Incentives.scss';

const Incentives = () => {
  return (
    <div className="incentives-catalog-container">
      <zr-incentives-catalog-widget></zr-incentives-catalog-widget>
    </div>
  );
};

export default Incentives;
